import { Stack, Tabs, Title } from '@mantine/core'
import { createFileRoute, Outlet, redirect, useLocation } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_admin/analytics')({
  component: RouteComponent,
  beforeLoad: ({ location }) => {
    const { pathname } = location
    if (pathname === '/analytics' || pathname === '/analytics/') {
      throw redirect({ to: 'cutting' })
    }
  },
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { pathname } = useLocation()
  const section = pathname.split('/').pop()

  return (
    <Stack gap="xl">
      <Title order={1}>Statystyki pracy</Title>
      <Tabs value={section} onChange={(value) => navigate({ to: `/analytics/${value}` })}>
        <Tabs.List>
          <Tabs.Tab value="cutting">Docinanie</Tabs.Tab>
          <Tabs.Tab value="sewing">Szycie</Tabs.Tab>
          <Tabs.Tab value="eyelet">Przelotki</Tabs.Tab>
        </Tabs.List>

        <Outlet />
      </Tabs>
    </Stack>
  )
}
